/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CandidateOfferFiltersModalityList model module.
 * @module model/CandidateOfferFiltersModalityList
 * @version v1
 */
class CandidateOfferFiltersModalityList {
    /**
     * Constructs a new <code>CandidateOfferFiltersModalityList</code>.
     * @alias module:model/CandidateOfferFiltersModalityList
     */
    constructor() { 
        
        CandidateOfferFiltersModalityList.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CandidateOfferFiltersModalityList</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CandidateOfferFiltersModalityList} obj Optional instance to populate.
     * @return {module:model/CandidateOfferFiltersModalityList} The populated <code>CandidateOfferFiltersModalityList</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CandidateOfferFiltersModalityList();

            if (data.hasOwnProperty('label')) {
                obj['label'] = ApiClient.convertToType(data['label'], 'String');
            }
            if (data.hasOwnProperty('value')) {
                obj['value'] = ApiClient.convertToType(data['value'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} label
 */
CandidateOfferFiltersModalityList.prototype['label'] = undefined;

/**
 * @member {Number} value
 */
CandidateOfferFiltersModalityList.prototype['value'] = undefined;






export default CandidateOfferFiltersModalityList;

